import * as React from "react";
/**
 * This icon from MDL2 is not available in @fluentui/react-icons
 * So we have to create the react icon component ourselves
 */ export const NoFlaggedEmailDarkMode = (props)=>/*#__PURE__*/ React.createElement("svg", {
        width: "188",
        height: "188",
        viewBox: "0 0 188 188",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#clip0_278_18456)"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: "188",
        height: "188",
        fill: "url(#paint0_radial_278_18456)"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: "188",
        height: "188",
        fill: "url(#paint1_radial_278_18456)"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: "188",
        height: "188",
        fill: "url(#paint2_radial_278_18456)"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: "188",
        height: "188",
        fill: "url(#paint3_radial_278_18456)"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: "188",
        height: "188",
        fill: "url(#paint4_radial_278_18456)"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: "188",
        height: "188",
        fill: "url(#paint5_radial_278_18456)"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: "188",
        height: "188",
        fill: "url(#paint6_radial_278_18456)"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: "188",
        height: "188",
        fill: "url(#paint7_radial_278_18456)"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: "188",
        height: "188",
        fill: "url(#paint8_radial_278_18456)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M27.825 48.9282C27.825 41.9842 33.4543 36.3549 40.3983 36.3549H130.743C137.687 36.3549 143.316 41.9842 143.316 48.9282V139.072C143.316 146.016 137.687 151.645 130.743 151.645H40.3983C33.4543 151.645 27.825 146.016 27.825 139.072V48.9282Z",
        fill: "url(#paint9_linear_278_18456)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M27.825 48.9282C27.825 41.9842 33.4543 36.3549 40.3983 36.3549H130.743C137.687 36.3549 143.316 41.9842 143.316 48.9282V139.072C143.316 146.016 137.687 151.645 130.743 151.645H40.3983C33.4543 151.645 27.825 146.016 27.825 139.072V48.9282Z",
        fill: "url(#paint10_linear_278_18456)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M27.825 48.9282C27.825 41.9842 33.4543 36.3549 40.3983 36.3549H130.743C137.687 36.3549 143.316 41.9842 143.316 48.9282V139.072C143.316 146.016 137.687 151.645 130.743 151.645H40.3983C33.4543 151.645 27.825 146.016 27.825 139.072V48.9282Z",
        fill: "url(#paint11_radial_278_18456)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M27.825 48.9282C27.825 41.9842 33.4543 36.3549 40.3983 36.3549H130.743C137.687 36.3549 143.316 41.9842 143.316 48.9282V139.072C143.316 146.016 137.687 151.645 130.743 151.645H40.3983C33.4543 151.645 27.825 146.016 27.825 139.072V48.9282Z",
        fill: "url(#paint12_radial_278_18456)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M27.825 48.9282C27.825 41.9842 33.4543 36.3549 40.3983 36.3549H130.743C137.687 36.3549 143.316 41.9842 143.316 48.9282V139.072C143.316 146.016 137.687 151.645 130.743 151.645H40.3983C33.4543 151.645 27.825 146.016 27.825 139.072V48.9282Z",
        fill: "url(#paint13_radial_278_18456)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M27.825 48.9282C27.825 41.9842 33.4543 36.3549 40.3983 36.3549H130.743C137.687 36.3549 143.316 41.9842 143.316 48.9282V139.072C143.316 146.016 137.687 151.645 130.743 151.645H40.3983C33.4543 151.645 27.825 146.016 27.825 139.072V48.9282Z",
        fill: "url(#paint14_radial_278_18456)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M27.825 48.9282C27.825 41.9842 33.4543 36.3549 40.3983 36.3549H130.743C137.687 36.3549 143.316 41.9842 143.316 48.9282V139.072C143.316 146.016 137.687 151.645 130.743 151.645H40.3983C33.4543 151.645 27.825 146.016 27.825 139.072V48.9282Z",
        fill: "url(#paint15_radial_278_18456)",
        fillOpacity: "0.9"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M27.825 48.9282C27.825 41.9842 33.4543 36.3549 40.3983 36.3549H130.743C137.687 36.3549 143.316 41.9842 143.316 48.9282V139.072C143.316 146.016 137.687 151.645 130.743 151.645H40.3983C33.4543 151.645 27.825 146.016 27.825 139.072V48.9282Z",
        fill: "url(#paint16_radial_278_18456)",
        fillOpacity: "0.4"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M27.825 48.9282C27.825 41.9842 33.4543 36.3549 40.3983 36.3549H130.743C137.687 36.3549 143.316 41.9842 143.316 48.9282V139.072C143.316 146.016 137.687 151.645 130.743 151.645H40.3983C33.4543 151.645 27.825 146.016 27.825 139.072V48.9282Z",
        fill: "url(#paint17_radial_278_18456)",
        fillOpacity: "0.4"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M27.825 48.9282C27.825 41.9842 33.4543 36.3549 40.3983 36.3549H130.743C137.687 36.3549 143.316 41.9842 143.316 48.9282V139.072C143.316 146.016 137.687 151.645 130.743 151.645H40.3983C33.4543 151.645 27.825 146.016 27.825 139.072V48.9282Z",
        fill: "url(#paint18_radial_278_18456)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M130.725 36.3549H40.4193C33.4883 36.3549 27.8696 41.9736 27.8696 48.9046V58.7233H143.275V48.9046C143.275 41.9736 137.656 36.3549 130.725 36.3549Z",
        fill: "url(#paint19_radial_278_18456)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M130.725 36.3549H40.4193C33.4883 36.3549 27.8696 41.9736 27.8696 48.9046V58.7233H143.275V48.9046C143.275 41.9736 137.656 36.3549 130.725 36.3549Z",
        fill: "url(#paint20_linear_278_18456)",
        fillOpacity: "0.4"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M130.725 36.3549H40.4193C33.4883 36.3549 27.8696 41.9736 27.8696 48.9046V58.7233H143.275V48.9046C143.275 41.9736 137.656 36.3549 130.725 36.3549Z",
        fill: "url(#paint21_linear_278_18456)",
        fillOpacity: "0.4"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M130.725 36.3549H40.4193C33.4883 36.3549 27.8696 41.9736 27.8696 48.9046V58.7233H143.275V48.9046C143.275 41.9736 137.656 36.3549 130.725 36.3549Z",
        fill: "url(#paint22_radial_278_18456)",
        fillOpacity: "0.5"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M115.79 124.4C115.79 135.209 107.028 143.971 96.2197 143.971C85.4112 143.971 76.6492 135.209 76.6492 124.4C76.6492 113.592 85.4112 104.83 96.2197 104.83C107.028 104.83 115.79 113.592 115.79 124.4Z",
        fill: "#262626"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M115.79 124.4C115.79 135.209 107.028 143.971 96.2197 143.971C85.4112 143.971 76.6492 135.209 76.6492 124.4C76.6492 113.592 85.4112 104.83 96.2197 104.83C107.028 104.83 115.79 113.592 115.79 124.4Z",
        fill: "url(#paint23_radial_278_18456)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M115.79 124.4C115.79 135.209 107.028 143.971 96.2197 143.971C85.4112 143.971 76.6492 135.209 76.6492 124.4C76.6492 113.592 85.4112 104.83 96.2197 104.83C107.028 104.83 115.79 113.592 115.79 124.4Z",
        fill: "url(#paint24_radial_278_18456)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M115.79 124.4C115.79 135.209 107.028 143.971 96.2197 143.971C85.4112 143.971 76.6492 135.209 76.6492 124.4C76.6492 113.592 85.4112 104.83 96.2197 104.83C107.028 104.83 115.79 113.592 115.79 124.4Z",
        fill: "url(#paint25_radial_278_18456)",
        fillOpacity: "0.6"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: "138.084",
        cy: "221.647",
        r: "30.8973",
        transform: "rotate(-46.7507 138.084 221.647)",
        fill: "url(#paint26_radial_278_18456)"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: "138.084",
        cy: "221.647",
        r: "30.8973",
        transform: "rotate(-46.7507 138.084 221.647)",
        fill: "url(#paint27_radial_278_18456)",
        fillOpacity: "0.8"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M138.192 124.4C138.192 135.209 129.43 143.971 118.622 143.971C107.813 143.971 99.0511 135.209 99.0511 124.4C99.0511 113.592 107.813 104.83 118.622 104.83C129.43 104.83 138.192 113.592 138.192 124.4Z",
        fill: "url(#paint28_linear_278_18456)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M138.192 124.4C138.192 135.209 129.43 143.971 118.622 143.971C107.813 143.971 99.0511 135.209 99.0511 124.4C99.0511 113.592 107.813 104.83 118.622 104.83C129.43 104.83 138.192 113.592 138.192 124.4Z",
        fill: "url(#paint29_radial_278_18456)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M138.192 124.4C138.192 135.209 129.43 143.971 118.622 143.971C107.813 143.971 99.0511 135.209 99.0511 124.4C99.0511 113.592 107.813 104.83 118.622 104.83C129.43 104.83 138.192 113.592 138.192 124.4Z",
        fill: "url(#paint30_radial_278_18456)",
        fillOpacity: "0.5"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M160.398 124.401C160.398 135.593 151.325 144.666 140.133 144.666C128.941 144.666 119.867 135.593 119.867 124.401C119.867 113.209 128.941 104.135 140.133 104.135C151.325 104.135 160.398 113.209 160.398 124.401Z",
        fill: "url(#paint31_linear_278_18456)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M160.398 124.401C160.398 135.593 151.325 144.666 140.133 144.666C128.941 144.666 119.867 135.593 119.867 124.401C119.867 113.209 128.941 104.135 140.133 104.135C151.325 104.135 160.398 113.209 160.398 124.401Z",
        fill: "url(#paint32_radial_278_18456)",
        fillOpacity: "0.9"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M160.398 124.401C160.398 135.593 151.325 144.666 140.133 144.666C128.941 144.666 119.867 135.593 119.867 124.401C119.867 113.209 128.941 104.135 140.133 104.135C151.325 104.135 160.398 113.209 160.398 124.401Z",
        fill: "url(#paint33_radial_278_18456)",
        fillOpacity: "0.3"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M160.398 124.401C160.398 135.593 151.325 144.666 140.133 144.666C128.941 144.666 119.867 135.593 119.867 124.401C119.867 113.209 128.941 104.135 140.133 104.135C151.325 104.135 160.398 113.209 160.398 124.401Z",
        fill: "url(#paint34_radial_278_18456)",
        fillOpacity: "0.3"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M160.398 124.401C160.398 135.593 151.325 144.666 140.133 144.666C128.941 144.666 119.867 135.593 119.867 124.401C119.867 113.209 128.941 104.135 140.133 104.135C151.325 104.135 160.398 113.209 160.398 124.401Z",
        fill: "url(#paint35_radial_278_18456)",
        fillOpacity: "0.9"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M140.139 113.501C137.081 113.501 134.603 115.998 134.603 119.079C134.603 122.159 137.081 124.656 140.139 124.656C143.197 124.656 145.676 122.159 145.676 119.079C145.676 115.998 143.197 113.501 140.139 113.501Z",
        fill: "url(#paint36_linear_278_18456)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M140.139 113.501C137.081 113.501 134.603 115.998 134.603 119.079C134.603 122.159 137.081 124.656 140.139 124.656C143.197 124.656 145.676 122.159 145.676 119.079C145.676 115.998 143.197 113.501 140.139 113.501Z",
        fill: "url(#paint37_radial_278_18456)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M133.627 127.323C132.328 127.323 131.274 128.384 131.274 129.693L131.274 130.112C131.274 132.207 132.349 133.775 133.998 134.786C135.62 135.781 137.799 136.247 140.132 136.247C142.465 136.247 144.645 135.781 146.267 134.786C147.916 133.775 148.991 132.207 148.991 130.112L148.991 129.693C148.991 128.384 147.937 127.323 146.638 127.323H133.627Z",
        fill: "url(#paint38_linear_278_18456)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M133.627 127.323C132.328 127.323 131.274 128.384 131.274 129.693L131.274 130.112C131.274 132.207 132.349 133.775 133.998 134.786C135.62 135.781 137.799 136.247 140.132 136.247C142.465 136.247 144.645 135.781 146.267 134.786C147.916 133.775 148.991 132.207 148.991 130.112L148.991 129.693C148.991 128.384 147.937 127.323 146.638 127.323H133.627Z",
        fill: "url(#paint39_linear_278_18456)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M133.627 127.323C132.328 127.323 131.274 128.384 131.274 129.693L131.274 130.112C131.274 132.207 132.349 133.775 133.998 134.786C135.62 135.781 137.799 136.247 140.132 136.247C142.465 136.247 144.645 135.781 146.267 134.786C147.916 133.775 148.991 132.207 148.991 130.112L148.991 129.693C148.991 128.384 147.937 127.323 146.638 127.323H133.627Z",
        fill: "url(#paint40_radial_278_18456)"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: "87.8209",
        cy: "122.091",
        r: "0.367188",
        fill: "#3D35B1"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: "94.6508",
        cy: "137.513",
        r: "0.367188",
        fill: "#3D35B1"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: "94.4672",
        cy: "112.407",
        r: "0.550781",
        fill: "#3D35B1"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: "87.2701",
        cy: "132.694",
        r: "0.550781",
        fill: "#3D35B1"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint0_radial_278_18456",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(139.531 103.914) rotate(-89.3389) scale(95.4751 27.0061)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.161914",
        stopColor: "#0E0E0E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.852041",
        stopColor: "#0E0E0E",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint1_radial_278_18456",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(145.406 129.617) rotate(-73.6105) scale(26.0263 25.7453)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.67914",
        stopColor: "#0E0E0E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#0E0E0E",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint2_radial_278_18456",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(48.4688 143.937) scale(33.4141 25.3548)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.262062",
        stopColor: "#0E0E0E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.890072",
        stopColor: "#0E0E0E",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint3_radial_278_18456",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(114.195 139.531) scale(51.4062 32.1532)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.428571",
        stopColor: "#0E0E0E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.978571",
        stopColor: "#0E0E0E",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint4_radial_278_18456",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(72.7031 151.648) rotate(0.72311) scale(87.2846 25.6918)"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#0E0E0E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.852041",
        stopColor: "#0E0E0E",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint5_radial_278_18456",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(29.9258 94) rotate(-90.4709) scale(67.014 19.9243)"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#595959"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#262626",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint6_radial_278_18456",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(40.0234 51.7734) rotate(83.6964) scale(31.7702 27.0479)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.355545",
        stopColor: "#595959"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#262626",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint7_radial_278_18456",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(70.8672 39.2891) rotate(178.573) scale(51.6058 19.9506)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.117407",
        stopColor: "#595959"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#262626",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint8_radial_278_18456",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(113.645 40.207) rotate(-178.973) scale(51.2309 19.8057)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.117407",
        stopColor: "#595959"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#262626",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint9_linear_278_18456",
        x1: "85.5705",
        y1: "55.5002",
        x2: "85.5705",
        y2: "152.842",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.0201027",
        stopColor: "#0E0E0E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.151106",
        stopColor: "#262626"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.9255",
        stopColor: "#262626"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#595959"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint10_linear_278_18456",
        x1: "25.0858",
        y1: "96.0289",
        x2: "144.685",
        y2: "96.2965",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.0297223",
        stopColor: "#0E0E0E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.110046",
        stopColor: "#262626",
        stopOpacity: "0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.917761",
        stopColor: "#262626",
        stopOpacity: "0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.993747",
        stopColor: "#595959"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint11_radial_278_18456",
        cx: "0",
        cy: "0",
        r: "1",
        gradientTransform: "matrix(13.0178 13.8245 -14.2371 13.5893 130.329 89.9571)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.447571",
        stopColor: "#0E0E0E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#262626",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint12_radial_278_18456",
        cx: "0",
        cy: "0",
        r: "1",
        gradientTransform: "matrix(14.0878 13.4654 -13.8673 14.7062 94.1292 90.4957)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.447571",
        stopColor: "#0E0E0E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#262626",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint13_radial_278_18456",
        cx: "0",
        cy: "0",
        r: "1",
        gradientTransform: "matrix(13.1962 15.0813 -15.5314 13.7754 56.324 91.0343)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.447571",
        stopColor: "#0E0E0E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#262626",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint14_radial_278_18456",
        cx: "0",
        cy: "0",
        r: "1",
        gradientTransform: "matrix(13.7311 14.1836 -14.6069 14.3339 56.859 126.404)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.447571",
        stopColor: "#0E0E0E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#262626",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint15_radial_278_18456",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(98.7734 126.863) rotate(51.1615) scale(22.9811 24.5755)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.792673",
        stopColor: "#0E0E0E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.965935",
        stopColor: "#262626",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint16_radial_278_18456",
        cx: "0",
        cy: "0",
        r: "1",
        gradientTransform: "matrix(11.6582 17.625 -18.1574 12.1789 122.182 130.076)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.802503",
        stopColor: "#0E0E0E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#262626",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint17_radial_278_18456",
        cx: "0",
        cy: "0",
        r: "1",
        gradientTransform: "matrix(13.2188 15.6055 -16.0576 13.78 144.947 129.617)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.855871",
        stopColor: "#0E0E0E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#262626",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint18_radial_278_18456",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(93.8164 121.355) rotate(53.7462) scale(22.1978 24.185)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.676523",
        stopColor: "#595959"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#262626",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint19_radial_278_18456",
        cx: "0",
        cy: "0",
        r: "1",
        gradientTransform: "matrix(-121.201 3.58509 -3.45961 -116.903 144.986 36.3549)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.174483",
        stopColor: "#4894FE"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.743917",
        stopColor: "#FA85FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.995485",
        stopColor: "#FF9514"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint20_linear_278_18456",
        x1: "85.5836",
        y1: "60.142",
        x2: "85.5836",
        y2: "35.3547",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.0647482",
        stopColor: "white"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.197842",
        stopColor: "white",
        stopOpacity: "0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.805755",
        stopColor: "white",
        stopOpacity: "0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.94964",
        stopColor: "white"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint21_linear_278_18456",
        x1: "145.159",
        y1: "58.7154",
        x2: "26.365",
        y2: "58.7154",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.0181148",
        stopColor: "white"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.0436403",
        stopColor: "white",
        stopOpacity: "0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.958806",
        stopColor: "white",
        stopOpacity: "0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.98358",
        stopColor: "white"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint22_radial_278_18456",
        cx: "0",
        cy: "0",
        r: "1",
        gradientTransform: "matrix(-71.3477 0.178324 -0.134221 -53.6764 85.6613 71.0199)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.877613",
        stopColor: "white",
        stopOpacity: "0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.967544",
        stopColor: "white"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint23_radial_278_18456",
        cx: "0",
        cy: "0",
        r: "1",
        gradientTransform: "matrix(22.9585 19.7007 -16.1997 18.8851 89.981 118.459)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.628607",
        stopColor: "#262626",
        stopOpacity: "0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#595959"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint24_radial_278_18456",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(99.7343 128.708) rotate(43.55) scale(22.1529)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.676428",
        stopColor: "#0E0E0E",
        stopOpacity: "0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#0E0E0E"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint25_radial_278_18456",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(115.79 129.617) rotate(17.1882) scale(24.851)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.616288",
        stopColor: "#0E0E0E"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.858035",
        stopColor: "#0E0E0E",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint26_radial_278_18456",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(143.928 207.487) rotate(108.435) scale(56.8016)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.0264604",
        stopColor: "#C8F5B7"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.25",
        stopColor: "#96EB76"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.524204",
        stopColor: "#42B870"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.785418",
        stopColor: "#22918B"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint27_radial_278_18456",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(138.084 221.647) rotate(97.8153) scale(54.8461)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.482881",
        stopColor: "#595959",
        stopOpacity: "0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.640053",
        stopColor: "#8C8C8C"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint28_linear_278_18456",
        x1: "104.04",
        y1: "106.273",
        x2: "126.104",
        y2: "143.971",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.314895",
        stopColor: "#FC92CB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.832932",
        stopColor: "#FF921F"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint29_radial_278_18456",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(118.622 124.4) rotate(90) scale(19.5705)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.773146",
        stopColor: "#FC92CB",
        stopOpacity: "0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#FECBE6"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint30_radial_278_18456",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(130.535 132.463) rotate(-125.47) scale(18.0343 15.2038)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.64017",
        stopColor: "#CA6407"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#FF922A",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint31_linear_278_18456",
        x1: "118.429",
        y1: "106.541",
        x2: "136.732",
        y2: "146.234",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.208361",
        stopColor: "#66C0FF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.964844",
        stopColor: "#367AF2"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint32_radial_278_18456",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(141.051 124.401) rotate(86.3296) scale(20.307)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.818945",
        stopColor: "#5AC1ED",
        stopOpacity: "0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#9DEAFF"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint33_radial_278_18456",
        cx: "0",
        cy: "0",
        r: "1",
        gradientTransform: "matrix(2.66853 14.9195 -14.9031 2.51945 142.854 122.311)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.258887",
        stopColor: "#0E0EA3"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.559989",
        stopColor: "#60A6F9",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint34_radial_278_18456",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(143.339 132.864) rotate(83.2902) scale(16.6102 29.5)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.24616",
        stopColor: "#0E0EA3"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.460117",
        stopColor: "#3984F3",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint35_radial_278_18456",
        cx: "0",
        cy: "0",
        r: "1",
        gradientTransform: "matrix(53.9415 41.9824 -28.4195 32.5196 117.583 102.684)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.171034",
        stopColor: "#EBC7FA"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.756423",
        stopColor: "#8AD5FD",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint36_linear_278_18456",
        x1: "136.651",
        y1: "114.825",
        x2: "143.277",
        y2: "124.709",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.185",
        stopColor: "#595959"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.71525",
        stopColor: "#262626"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint37_radial_278_18456",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(140.139 119.079) rotate(-137.038) scale(8.1838 8.09305)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.516644",
        stopColor: "#262626",
        stopOpacity: "0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.788287",
        stopColor: "#262626"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint38_linear_278_18456",
        x1: "134.551",
        y1: "128.382",
        x2: "138.005",
        y2: "138.686",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.185",
        stopColor: "#595959"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.71525",
        stopColor: "#262626"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint39_linear_278_18456",
        x1: "140.132",
        y1: "139.111",
        x2: "140.132",
        y2: "124.459",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.683602",
        stopColor: "#262626",
        stopOpacity: "0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.860792",
        stopColor: "#262626"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint40_radial_278_18456",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(140.132 129.837) rotate(-90) scale(8.71599 13.8789)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.515703",
        stopColor: "#262626",
        stopOpacity: "0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "0.64562",
        stopColor: "#262626"
    })), /*#__PURE__*/ React.createElement("clipPath", {
        id: "clip0_278_18456"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: "188",
        height: "188",
        fill: "white"
    }))));
